export * from './client-inventory.routes';



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/fulfillment.release/src/app/client-inventory/index.ts